export const getPropertyLandingState = (selectedLanding) => {
    if (!selectedLanding) {
        return null;
    }

    const propertyLandingRef =
        selectedLanding.mainLandingRef || selectedLanding.history?.[0] || selectedLanding.landingRef || null;

    if (!propertyLandingRef) {
        return null;
    }

    return {
        ...selectedLanding,
        landingRef: propertyLandingRef,
        topBar: null,
        history: [],
    };
};
